// src/shared/api/user.ts

import { TelegramUser } from '../../../entities/eco-drops/hooks/types';
import { ecoDropsApi } from './base';
import { AuthData } from './types';

export const UserApi = {
  getUser: async () => {
    const { data } = await ecoDropsApi.get('/user');
    return data;
  },

  logout: async () => {
    const { data } = await ecoDropsApi.post(
      '/user/logout',
      {},
      {
        withCredentials: true,
      },
    );
    return data;
  },

  auth: async (authData: AuthData) => {
    const { data } = await ecoDropsApi.post('/user/auth', authData, {
      withCredentials: true,
    });
    return data;
  },

  authTelegram: async (telegramData: TelegramUser) => {
    const { data } = await ecoDropsApi.post(
      '/user/auth/telegram',
      telegramData,
    );
    return data;
  },

  getProgress: async (campaignId?: string) => {
    const url = campaignId ? `/user/progress/${campaignId}` : '/user/progress';
    const { data } = await ecoDropsApi.get(url);
    return data;
  },

  setProgress: async (campaignId: string, taskId: string) => {
    const { data } = await ecoDropsApi.post(
      `/user/progress/${campaignId}/${taskId}`,
    );
    return data;
  },
};
